module.exports = __webpack_public_path__ + "img/twelve-logo-white.657ae4a2.svg";